module.exports = __webpack_public_path__ + "img/ce3cca6.png";